export const SET_APPLICATION = 'SET_APPLICATION';
export const SET_COLUMN = 'SET_COLUMN';
export const SET_DIALOG = 'SET_DIALOG';
export const SET_GLOBAL = 'SET_GLOBAL';
export const SET_MENU = 'SET_MENU';

export const SET_POST_APPROVAL = 'SET_POST_APPROVAL';
export const SET_USER = 'SET_USER';
export const SET_SYSTEM = 'SET_SYSTEM';
export const SET_SYSTEM_MESSAGE = 'SET_SYSTEM_MESSAGE';
export const SET_APPLICATION_DETAIL = 'SET_APPLICATION_DETAIL';
export const SET_USER_ACCOUNT = 'SET_USER_ACCOUNT';
export const SET_EMAIL_DOMAIN = 'SET_EMAIL_DOMAIN';
export const GET_EMAIL_DOMAIN_LIST = 'GET_EMAIL_DOMAIN_LIST';
export const UPDATE_EMAIL_DOMAIN = 'UPDATE_EMAIL_DOMAIN';

export const SET_EMAIL_TEMPLATE = 'SET_EMAIL_TEMPLATE';
export const GET_EMAIL_TEMPLATE_LIST = 'GET_EMAIL_TEMPLATE_LIST';
export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE';

export const UPDATE_USER = 'UPDATE_USER';

export const UPDATE_REMOTE_USER = 'UPDATE_REMOTE_USER';
export const UPDATE_AUTH_USER_PASSCODE = 'UPDATE_AUTH_USER_PASSCODE';

export const UPDATE_APPLICATION_COLUMN = 'UPDATE_APPLICATION_COLUMN';
export const UPDATE_POST_APPROVAL_COLUMN = 'UPDATE_POST_APPROVAL_COLUMN';

export const APPLICATION_UPDATE = 'APPLICATION_UPDATE';
export const APPLICATION_UPDATE_POST_APPROVAL_FORM_DATA = 'APPLICATION_UPDATE_POST_APPROVAL_FORM_DATA';
export const APPLICATION_FETCH = 'APPLICATION_FETCH';
export const APPLICATION_FETCH_REFRESH = 'APPLICATION_FETCH_REFRESH';

export const APPLICATION_LIST_REFRESH = 'APPLICATION_LIST_REFRESH';

export const POST_APPROVAL_CREATE = 'POST_APPROVAL_CREATE';
export const POST_APPROVAL_UPDATE = 'POST_APPROVAL_UPDATE';
export const GET_CTCANDCTI_FILE = 'GET_CTCANDCTI_FILE';

export const CREATE_REVIEWER = 'CREATE_REVIEWER';
export const EDIT_REVIEWER = 'EDIT_REVIEWER';
export const DELETE_REVIEWER = 'DELETE_REVIEWER';
export const CREATE_REVIEW_PANEL = 'CREATE_REVIEW_PANEL';
export const EDIT_REVIEW_PANEL = 'EDIT_REVIEW_PANEL';
export const DELETE_REVIEW_PANEL = 'DELETE_REVIEW_PANEL';
export const SET_REVIEWER = 'SET_REVIEWER';

export const SYSTEM_GET_USER_ACCOUNT = 'SYSTEM_GET_USER_ACCOUNT';
export const SYSTEM_GET_USER_ACCOUNT_DETAIL = 'SYSTEM_GET_USER_ACCOUNT_DETAIL';
export const SYSTEM_UPDATE_USER_ACCOUNT = 'SYSTEM_UPDATE_USER_ACCOUNT';
export const SYSTEM_GET_USER_GROUP = 'SYSTEM_GET_USER_GROUP';

export const SYSTEM_EDIT_USER_ACCOUNT = 'SYSTEM_EDIT_USER_ACCOUNT';
export const SYSTEM_DELETE_USER_ACCOUNT = 'SYSTEM_DELETE_USER_ACCOUNT';
export const SYSTEM_CREATE_EMAIL_DOMAIN = 'SYSTEM_CREATE_EMAIL_DOMAIN';
export const SYSTEM_EDIT_EMAIL_DOMAIN = 'SYSTEM_EDIT_EMAIL_DOMAIN';
export const SYSTEM_DELETE_EMAIL_DOMAIN = 'SYSTEM_DELETE_EMAIL_DOMAIN';

export const EDIT_GLOBAL_VARIABLES = 'EDIT_GLOBAL_VARIABLES';
export const GET_GLOBAL_VARIABLES = 'GET_GLOBAL_VARIABLES';

export const SYSTEM_EDIT_EMAIL_TEMPLATE = 'SYSTEM_EDIT_EMAIL_TEMPLATE';
export const SYSTEM_EDIT_BROADCAST_MESSAGE = 'SYSTEM_EDIT_BROADCAST_MESSAGE';
export const SYSTEM_EDIT_SYSTEM_NEWS = 'SYSTEM_EDIT_SYSTEM_NEWS';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const SET_FORMATTED_HOSPITAL_DATA = 'SET_FORMATTED_HOSPITAL_DATA';

export const SET_LANDING_DATA = 'SET_LANDING_DATA';
export const FETCH_LANDING_DATA = 'FETCH_LANDING_DATA';

export const FETCH_USER = 'FETCH_USER';

export const APPLICATION_DETAIL_FETCH = 'APPLICATION_DETAIL_FETCH';
export const APPLICATION_DETAIL_UPDATE = 'APPLICATION_DETAIL_UPDATE';
export const UPDATE_APPLICATION_FORM_DETAIL_VALID = 'UPDATE_APPLICATION_FORM_DETAIL_VALID';
export const UPDATE_APPLICATION_DETAIL_POST_DATA = 'UPDATE_APPLICATION_DETAIL_POST_DATA';
export const UPDATE_APPLICATION_SITE_DETAIL_POST_DATA = 'UPDATE_APPLICATION_SITE_DETAIL_POST_DATA';
export const SAVE_APPLICATION_DETAIL = 'SAVE_APPLICATION_DETAIL';
export const SET_APPLICATION_DETAIL_POST_DATA = 'SET_APPLICATION_DETAIL_POST_DATA';

export const SYSTEM_HANDLE_FORCE_CHECK_VALIDATION = 'SYSTEM_HANDLE_FORCE_CHECK_VALIDATION';
export const FETCH_APPLICATION_DETAIL_FINISH = 'FETCH_APPLICATION_DETAIL_FINISH';

export const SAVE_REMOTE_APPLICATION_DETAIL = 'SAVE_REMOTE_APPLICATION_DETAIL';
export const UPDATE_REMOTE_APPLICATION_CUSTOM_DATA = 'UPDATE_REMOTE_APPLICATION_CUSTOM_DATA';
export const RESET_APPLICATION_FORM_INITIAL_POST_DATA = 'RESET_APPLICATION_FORM_INITIAL_POST_DATA';
export const ADD_DELETE_REQUEST = 'ADD_DELETE_REQUEST';
export const REMOVE_DELETE_REQUEST = 'REMOVE_DELETE_REQUEST';

export const SAVE_CTC_DETAIL = 'SAVE_CTC_DETAIL';
export const SAVE_CTI_DETAIL = 'SAVE_CTI_DETAIL';
export const SAVE_CTA_DETAIL = 'SAVE_CTA_DETAIL';
export const CREATE_CTC_CTI = 'CREATE_CTC_CTI';

export const GET_DOWNLOAD_DOCUMENT = 'GET_DOWNLOAD_DOCUMENT';
export const UNSET_APPLICATION_FORM_POST_DATA_KEY = 'UNSET_APPLICATION_FORM_POST_DATA_KEY';

export const DELETE_REMOVE_REQUEST = 'DELETE_REMOVE_REQUEST';

export const UPDATE_REMOVE_REQUEST_DATA = 'UPDATE_REMOVE_REQUEST_DATA';

export const UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE = 'UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE';
export const SET_APPLICATION_DETAIL_VALID = 'SET_APPLICATION_DETAIL_VALID';

export const UPDATE_FORM_VALIDITY = 'UPDATE_FORM_VALIDITY';

export const UPDATE_SITE_INFO_INSIDE_VALIDITY = 'UPDATE_SITE_INFO_INSIDE_VALIDITY';

export const APPLICATION_DETAIL_REFRESH = 'APPLICATION_DETAIL_REFRESH';

export const POST_APPROVAL_LIST_FETCH = 'POST_APPROVAL_LIST_FETCH';
export const POST_APPROVAL_LIST_FETCH_COMPLETE = 'POST_APPROVAL_LIST_FETCH_COMPLETE';
export const POST_APPROVAL_LIST_FETCH_WITH_CANCEL = 'POST_APPROVAL_LIST_FETCH_WITH_CANCEL';

export const POST_APPROVAL_DETAIL_FETCH = 'POST_APPROVAL_DETAIL_FETCH';

export const REMOVE_SITE_POST_DATA = 'REMOVE_SITE_POST_DATA';

export const UPDATE_APPLICATION_STATUS = 'UPDATE_APPLICATION_STATUS';

export const RETURN_TO_SITE = 'RETURN_TO_SITE';

export const SEND_TO_COORDINATING_INVESTIGATOR = 'SEND_TO_COORDINATING_INVESTIGATOR';
export const SUBMIT_APPLICATION_FORM = 'SUBMIT_APPLICATION_FORM';

export const GET_DOWNLOAD_GENERATE_DOC = 'GET_DOWNLOAD_GENERATE_DOC';

export const UPDATE_APPLICATION_STATUS_WITH_DETAIL = 'UPDATE_APPLICATION_STATUS_WITH_DETAIL';

export const SET_TEXTFIELD_ON_BLUR = 'SET_TEXTFIELD_ON_BLUR';

export const UPDATE_USER_ACCOUNT_STATUS = 'UPDATE_USER_ACCOUNT_STATUS';

export const SET_GLOBAL_VARIABLES = 'SET_GLOBAL_VARIABLES';

export const SET_BROADCAST_MESSAGE = 'SET_BROADCAST_MESSAGE';
export const GET_BROADCAST_MESSAGE = 'GET_BROADCAST_MESSAGE';

export const FETCH_USER_MENU = 'FETCH_USER_MENU';

export const SET_USER_MENU = 'SET_USER_MENU';

export const LOAD_ALL_CONFIG = 'LOAD_ALL_CONFIG';

export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const FETCH_NOTIFICATION_ALL_LIST = 'FETCH_NOTIFICATION_ALL_LIST';
export const FETCH_NOTIFICATION_COUNT_OF_UNREAD = 'FETCH_NOTIFICATION_COUNT_OF_UNREAD';
export const FETCH_NOTIFICATION_MARK_READ = 'FETCH_NOTIFICATION_MARK_READ';

export const SET_SEARCH = 'SET_SEARCH';
export const GET_SEARCH_LIST = 'GET_SEARCH_LIST';
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const UPDATE_SEARCH_CONDITIONS = 'UPDATE_SEARCH_CONDITIONS';

export const SET_SITE_VALIDATION = 'SET_SITE_VALIDATION';
export const SET_STUDY_VALIDATION = 'SET_STUDY_VALIDATION';
export const CLEAR_FORM_VALIDATION = 'CLEAR_FORM_VALIDATION';

export const EXPORT_APPLICATION_SEARCH = 'EXPORT_APPLICATION_SEARCH';
export const EXPORT_APPLICATION_SEARCH_NTEC = 'EXPORT_APPLICATION_SEARCH_NTEC';
export const SET_TABLE_UI = 'SET_TABLE_UI';

export const SET_CLINICAL_STUDY_CATEGORIZATION = 'SET_CLINICAL_STUDY_CATEGORIZATION';
export const UPDATE_CLINICAL_STUDY_CATEGORIZATION = 'UPDATE_CLINICAL_STUDY_CATEGORIZATION';
export const RESET_CLINICAL_STUDY_CATEGORIZATION = 'RESET_CLINICAL_STUDY_CATEGORIZATION';
export const RESET_DOCUMENT_UPLOAD = 'RESET_DOCUMENT_UPLOAD';
export const SET_DOCUMENT_UPLOAD = 'SET_DOCUMENT_UPLOAD';
export const DOWNLOAD_APPLICATION = 'DOWNLOAD_APPLICATION';
export const CREATE_AMENDMENT_FORM = 'CREATE_AMENDMENT_FORM';

export const RESET_DECLARATION_AND_ENDORSEMENT = 'RESET_DECLARATION_AND_ENDORSEMENT';
export const SET_DECLARATION_AND_ENDORSEMENT = 'SET_DECLARATION_AND_ENDORSEMENT';

export const SAVE_DELEGATION = 'SAVE_DELEGATION';

export const APPLICATION_FETCH_WITH_CANCEL = 'APPLICATION_FETCH_WITH_CANCEL';
export const APPLICATION_FETCH_COMPLETE = 'APPLICATION_FETCH_COMPLETE';

export const CLEAR_APPLICATION_LIST = 'CLEAR_APPLICATION_LIST';
export const CLEAR_POST_APPROVAL_LIST = 'CLEAR_POST_APPROVAL_LIST';

export const CLEAR_UP_REDUX = 'CLEAR_UP_REDUX';

export const SET_TEXT_VALIDATION = 'SET_TEXT_VALIDATION';

export const CLEAR_TEXT_VALIDATION = 'CLEAR_TEXT_VALIDATION';
export const CLEAR_APPLICATION_DETAIL = 'CLEAR_APPLICATION_DETAIL';

export const INITIAL_SYSTEM_GLOBAL_DATA = 'INITIAL_SYSTEM_GLOBAL_DATA';

export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const UPDATE_COI_INVOLVED = 'UPDATE_COI_INVOLVED';
export const UPDATE_DECLARATION_NORMAL_POST_DATA = 'UPDATE_DECLARATION_NORMAL_POST_DATA';
export const DELETE_DECLARATION_NORMAL_DATA = 'DELETE_DECLARATION_NORMAL_DATA';
export const UPDATE_DECLARATION_STUDENT_POST_DATA = 'UPDATE_DECLARATION_STUDENT_POST_DATA';
export const UPDATE_DECLARE_STUDENT = 'UPDATE_DECLARE_STUDENT';

export const GET_REVIEWER_LIST = 'GET_REVIEWER_LIST';
export const CALL_LOGOUT_USER = 'CALL_LOGOUT_USER';

export const SET_REVIEW_PANEL = 'SET_REVIEW_PANEL';
export const GET_REVIEW_PANEL_LIST = 'GET_REVIEW_PANEL_LIST';
export const DELETE_REVIEW_PANEL_BUY_ID = 'DELETE_REVIEW_PANEL_BUY_ID';
export const GET_REVIEW_PANEL_BUY_ID = 'GET_REVIEW_PANEL_BUY_ID';
export const GET_REVIEW_PANEL_MEMBER_LIST = 'GET_REVIEW_PANEL_MEMBER_LIST';
export const ADD_REVIEW_PANEL_DATA = 'ADD_REVIEW_PANEL_DATA';
export const EDIT_REVIEW_PANEL_DATA = 'EDIT_REVIEW_PANEL_DATA';
export const UPDATE_SITE_DETAIL_INFO = 'UPDATE_SITE_DETAIL_INFO0';

export const SET_ARRANGE_MEETING = 'SET_ARRANGE_MEETING';
export const GET_APPLICATION_DOC_BYPARAMS = 'GET_APPLICATION_DOC_BYPARAMS';
export const GET_MEETING_ARRANGEMENT_MEMBER_LIST = 'GET_MEETING_ARRANGEMENT_MEMBER_LIST';
export const ADD_MEETING_ARRANGEMENT_FORM = 'ADD_MEETING_ARRANGEMENT_FORM';
export const EDIT_MEETING_ARRANGEMENT_FORM = 'EDIT_MEETING_ARRANGEMENT_FORM';

export const GET_MEETING_ARRANGE_LIST = 'GET_MEETING_ARRANGE_LIST';
export const GET_MEETING_ARRANGEMENT_FORM_DETAIL = 'GET_MEETING_ARRANGEMENT_FORM_DETAIL';

export const ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT = 'ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT';
export const SET_REVIEWER_RESULT = 'SET_REVIEWER_RESULT';
export const GET_TYPEOFREVIEW = 'GET_TYPEOFREVIEW';

export const SET_CONSOLIDATION = 'SET_CONSOLIDATION';
export const GET_CONSOLIDATION_DETAIL = 'GET_CONSOLIDATION_DETAIL';
export const SAVE_CONSOLIDATION_DETAIL = 'SAVE_CONSOLIDATION_DETAIL';
export const SUBMIT_CONSOLIDATION_DETAIL = 'SUBMIT_CONSOLIDATION_DETAIL';
export const CHECK_CONSOLIDATION_UPDATE = 'CHECK_CONSOLIDATION_UPDATE';
export const RESET_CONSOLIDATION = 'RESET_CONSOLIDATION';

export const UP_DATA_INITIAL = 'UP_DATA_INITIAL';
export const SET_SUSAR_REPORT = 'SET_SUSAR_REPORT';
export const SAVE_SUSAR = 'SAVE_SUSAR';
export const GET_SUSAR = 'GET_SUSAR';
export const SUBMIT_SUSAR = 'SUBMIT_SUSAR';

export const SET_PROGRESS_REPORT = 'SET_PROGRESS_REPORT';

export const GET_PROGRESS_REPORT = 'GET_PROGRESS_REPORT';
export const SAVE_PROGRESS_REPORT = 'SAVE_PROGRESS_REPORT';

export const GET_FINAL_REPORT = 'GET_FINAL_REPORT';
export const SAVE_FINAL_REPORT = 'SAVE_FINAL_REPORT';
export const SET_FINAL_REPORT = 'SET_FINAL_REPORT';

export const DOWNLOAD_APPROVAL_LETTER = 'DOWNLOAD_APPROVAL_LETTER';

export const SET_MISCELLANEOUS_REPORT = 'SET_MISCELLANEOUS_REPORT';
export const SAVE_MISCELLANEOUS = 'SAVE_MISCELLANEOUS';
export const GET_MISCELLANEOUS = 'GET_MISCELLANEOUS';
export const SUBMIT_MISCELLANEOUS = 'SUBMIT_MISCELLANEOUS';

export const INITIAL_PROGRESS_REPORT = 'INITIAL_PROGRESS_REPORT';

export const GET_SIGNED_DOCUMENT = 'GET_SIGNED_DOCUMENT';

export const SET_PROTOCOL_DEVIATION_REPORT = 'SET_PROTOCOL_DEVIATION_REPORT';
export const SAVE_PROTOCOL_DEVIATION = 'SAVE_PROTOCOL_DEVIATION';
export const GET_PROTOCOL_DEVIATION = 'GET_PROTOCOL_DEVIATION';
export const SUBMIT_PROTOCOL_DEVIATION = 'SUBMIT_PROTOCOL_DEVIATION';

export const SET_LOCAL_SAE_REPORT = 'SET_LOCAL_SAE_REPORT';
export const SAVE_LOCAL_SAE = 'SAVE_LOCAL_SAE';
export const GET_LOCAL_SAE = 'GET_LOCAL_SAE';
export const SUBMIT_LOCAL_SAE = 'SUBMIT_LOCAL_SAE';

export const GET_POST_APPROVAL_ZIP = 'GET_POST_APPROVAL_ZIP';

export const EXPORT_SITE_INFO = 'EXPORT_SITE_INFO';

// comment
export const SET_COMMENT = 'SET_COMMENT';

export const GET_ALL_COMMENT = 'GET_ALL_COMMENT';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const GET_COMMENT = 'GET_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const RESOLVE_COMMENT = 'RESOLVE_COMMENT';

export const SET_CURRENT_TAB_ID = 'SET_CURRENT_TAB_ID';
export const SET_ALL_COMMENTS = 'SET_ALL_COMMENTS';
export const UPDATE_DRAFT_COMMENT = 'UPDATE_DRAFT_COMMENT';
export const UPDATE_ALL_DRAFT_COMMENT = 'UPDATE_ALL_DRAFT_COMMENT';
export const GET_CHANGELOG_BY_ID = 'GET_CHANGELOG_BY_ID';
export const SET_CHANGELOG = 'SET_CHANGELOG';
export const EXPORT_SUMMARY = 'EXPORT_SUMMARY';

// search
export const CCO_RETURN_ACTION = 'CCO_RETURN_ACTION';
export const EXPORT_FOR_CCO = 'EXPORT_FOR_CCO';
export const SHOW_SELECT_TEMPLATE_BOX = 'SHOW_SELECT_TEMPLATE_BOX';
export const SET_SELECT_TEMPLATE_BOX = 'SET_SELECT_TEMPLATE_BOX';






